import _regeneratorRuntime from "C:\\Users\\Johan\\workspace\\resurrected\\common\\temp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import _asyncToGenerator from "C:\\Users\\Johan\\workspace\\resurrected\\common\\temp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "C:\\Users\\Johan\\workspace\\resurrected\\common\\temp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\Johan\\workspace\\resurrected\\common\\temp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import { mat4 } from "gl-matrix";

var Pipeline =
/*#__PURE__*/
function () {
  function Pipeline(context, name, topRenderer, projector) {
    _classCallCheck(this, Pipeline);

    this.context = context;
    this.name = name;
    this.topRenderer = topRenderer;
    this.isOn = false;

    this.projector = projector || function (width, height) {
      var projectionMatrix = mat4.create();
      mat4.perspective(projectionMatrix, Math.PI / 3, width / height, 0.1, 10.0);
      return projectionMatrix;
    };

    this.properties = {
      matrices: {
        view: mat4.create(),
        projection: this.projector(this.context.gl.drawingBufferWidth, this.context.gl.drawingBufferHeight)
      },
      vectors: {},
      positions: {},
      scalars: {}
    };
  }

  _createClass(Pipeline, [{
    key: "initAsync",
    value: function () {
      var _initAsync = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.topRenderer.initAsync();

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function initAsync() {
        return _initAsync.apply(this, arguments);
      }

      return initAsync;
    }()
  }, {
    key: "render",
    value: function render(frameInfo) {
      if (this.isOn) {
        var inheritedProperties = {};

        for (var _i = 0, _Object$keys = Object.keys(this.properties); _i < _Object$keys.length; _i++) {
          var key = _Object$keys[_i];
          inheritedProperties[key] = Object.create(this.properties[key]);
        }

        this.topRenderer.render(frameInfo, inheritedProperties);
      }
    }
  }, {
    key: "turnOn",
    value: function turnOn() {
      this.isOn = true;
    }
  }, {
    key: "turnOff",
    value: function turnOff() {
      this.isOn = false;
    }
  }, {
    key: "resize",
    value: function resize(width, height) {
      this.properties.matrices.projection = this.projector(width, height);
      this.topRenderer.resize(width, height);
    }
  }]);

  return Pipeline;
}();

export { Pipeline as default };